export default __webpack_public_path__ + "static/media/sound_poster_maus.d1b542d5.png";